import { render, staticRenderFns } from "./ManufacturerResource.vue?vue&type=template&id=63b6d151&scoped=true&"
import script from "./ManufacturerResource.vue?vue&type=script&lang=js&"
export * from "./ManufacturerResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b6d151",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
